var _g, _text;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoFull(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 56,
    viewBox: "0 0 112 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(42 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 4.25,
    stroke: "#C2A15E"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 1.4,
    fill: "#C2A15E"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#C2A15E",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 1V7M14 21v6M1 14h6M21 14h6M4.8 4.8l4.3 4.3M18.9 18.9l4.3 4.3M23.2 4.8l-4.3 4.3M9.1 18.9l-4.3 4.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 2l2.2 5.5M16.8 20.5L19 26M2 19l5.5-2.2M20.5 11.2L26 9M19 2l-2.2 5.5M11.2 20.5L9 26M2 9l5.5 2.2M20.5 16.8L26 19",
    opacity: 0.7
  })))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 56,
    y: 42,
    fill: "#ECE6DA",
    fontFamily: "Georgia, serif",
    fontSize: 10,
    textAnchor: "middle",
    letterSpacing: 1.4
  }, "THEGENIUS ID")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFull);
export default __webpack_public_path__ + "static/media/logo_full.53a5f5d5.svg";
export { ForwardRef as ReactComponent };